import React from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import { Typography, Box } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  section: {
    padding: theme.spacing(2, 0),
  },
  placeholder: {
    textAlign: "center",
    color: "#54606F",
    padding: theme.spacing(4),
  },
}));

const InformationSection = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Box className={classes.section}>
      <Typography className={classes.placeholder}>
        {t("Information section content will be implemented here")}
      </Typography>
    </Box>
  );
};

export default InformationSection;
